/**
 * Staff portals (management / operation / gi / account) keep their own views.
 * Only the Consultant role is bounced to /consultant/*.
 */
export function shouldRedirectToConsultantPortal(roleName) {
  return String(roleName ?? "").toUpperCase().trim() === "CONSULTANT";
}
